export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/homeIconGray.e8714d08.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};